/***
 * This module is used to perform various different API calls for data that don't necessarily need their own module
 *
 * ***/

import { RepositoryFactory } from 'src/api/repositories/RepositoryFactory'
const DailyNewsRepository = RepositoryFactory.get('dailyNews');
const CommunityPostsRepository = RepositoryFactory.get('communityPosts');
const VideoRepository = RepositoryFactory.get('video');
const NewsletterRepository = RepositoryFactory.get('newsletter');
const ContactRepository = RepositoryFactory.get('contact');

export default {
	namespaced: true,
	state: {
		articles: [],
		articlesLoading: false,
		articlesLoaded: false,
		communityPosts: [],
		communityPostsLoaded: false,
		videoLibraryData : {}, //holds data for all the video libraries
        videoLibraryLoaded : false, //flag to check if we should use axios to get the video library
	},

	actions: {
		getCommunityPosts({commit, state}, payload) {
			state.communityPostsLoading = true;

			return CommunityPostsRepository.getCommunityPosts().then((response) => {
				if (response.data.success) {
					commit('setCommunityPosts', response.data.data.posts);
					return response.data.data.posts;
				}
			}, (err) => {
				console.log(err);
			});
		},

		getArticles({commit}, payload) {

			return DailyNewsRepository.getArticles().then((response) => {
				commit('setArticlesLoading', true);
				if (response.data.success) {
					commit('setArticles', response.data.articles);
					commit('setArticlesLoaded', true);
					commit('setArticlesLoading', false);
					return response.data.articles;
				}
			}, (err) => {
				console.log(err);
			});
		},
		setArticles({commit}, payload) {
			commit("setArticles", payload);
		},
		setArticlesLoaded({commit}, payload) {
			commit("setArticlesLoaded", payload);
		},
		getVideoLibrary({commit, rootState}) {
			return VideoRepository.getVideos().then((response) => {
				if (response.data.success) {
					commit('setVideoLibraryData', response.data.library);
					return response.data.library;
				}
			}, (err) => {
				console.log(err);
			});

		},
		postNewsletterFormData({commit}, payload) {
			return NewsletterRepository.postFormData(payload);
		},
		submitContactData({commit}, data) {
			return ContactRepository.submit(data);
		}
	},
	mutations: {
		getArticles (state) {
			//
		},
		setArticles (state, articlesData ) {
			state.articles = articlesData;
		},
		setArticlesLoaded (state , flag) {
			state.articlesLoaded = flag
		},
		setArticlesLoading (state , flag) {
			state.articlesLoading = flag
		},
		setCommunityPosts ( state , posts) {
			state.communityPosts = posts;
			state.communityPostsLoaded = true;
			state.communityPostsLoading = false;
		},

		setVideoLibraryData ( state , libraryData) {
            state.videoLibraryLoaded = true;
            state.videoLibraryData = libraryData;
        },

	}
}